module.exports = "<h2 id=\"talk-by-martin-muzatko-https-twitter-com-martinmuzatko-\">Talk by <a href=\"https://twitter.com/martinmuzatko\">Martin Muzatko</a></h2>\n<p>Resources and Talk material: <a href=\"http://www.happy-css.com\">happy-css.com</a></p>\n<p>Source: <a href=\"https://github.com/MartinMuzatko/webpack-talk\">https://github.com/MartinMuzatko/webpack-talk</a></p>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./docs/thanks.md
 ** module id = 23
 ** module chunks = 0
 **/